import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class CardsBlock {
	constructor() {
		this.cards = document.querySelectorAll(".block__cards-row");
		this.footer = document.querySelector(".landing__footer");
		if (!this.cards.length) return;

		this.cardScrollEffect();
	}

	cardScrollEffect() {
		const cards = Array.from(this.cards);

		cards.forEach((card) => {
			const cardImage = card.querySelector(
				".block__cards-row__image img",
			);
			const cardContent = card.querySelectorAll(
				".block__cards-row__content p",
			);
			const cardButton = card.querySelectorAll(
				".block__cards-row__content .w__card__button",
			);

			const scrollOptions = {
				trigger: card,
				start: "top top",
				end: `bottom top`,
				scrub: true,
			};

			gsap.to(cardImage, {
				opacity: 0,
				width: "50%",
				scrollTrigger: scrollOptions,
			});

			gsap.to(cardContent, {
				opacity: 0,
				scrollTrigger: scrollOptions,
			});

			if (cardButton.length) {
				gsap.to(cardButton, {
					opacity: 0,
					scrollTrigger: scrollOptions,
				});
			}
		});
	}
}
